import React, { Component } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
import { authStore } from "../stores"
import styled from "styled-components"
import moment from "moment"

@observer
export default class OrderList extends Component {
  render() {
    return (
      <div>
        {authStore.recentStorePurchases
          .values()
          .sort((a, b) => b.time - a.time)
          .slice(0, this.props.limit || 25)
          .map(x => {
            return (
              <Link to={`/orders/${x.id}`} key={x.id} style={{ display: "block", marginBottom: 7 }}>
                <OrderItem>
                  <p>${x.total}</p>
                  <p>{moment(x.time).fromNow()}</p>
                </OrderItem>
              </Link>
            )
          })}
      </div>
    )
  }
}

const OrderItem = styled.div`
  width: 100%;
  background: #fff;
  color: #333;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/orders/OrderList.js